import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router'
import { Store } from '@ngrx/store'
import { combineLatest, Observable } from 'rxjs'
import {
  distinctUntilChanged,
  filter,
  map,
  shareReplay,
  startWith
} from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'
import { operationSelectors } from 'src/app/features/operation/operation.selectors'
import { ConfigurationService } from 'src/app/shared/services/configuration.service'

interface AppShellFooterConfig {
  showFooter: boolean
  showFooterInMobileApp: boolean
}

@Component({
  selector: 'app-shell-layout',
  templateUrl: './app-shell-layout.component.html',
  styleUrls: ['./app-shell-layout.component.scss']
})
export class AppShellLayoutComponent implements OnInit {
  public existPendingOperations$: Observable<boolean>
  public showFooter$: Observable<boolean>

  constructor(
    private store: Store<AppState>,
    private configurationService: ConfigurationService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.existPendingOperations$ = this.store
      .select(operationSelectors.selectExistPendingOperations)
      .pipe(
        distinctUntilChanged(),
        shareReplay({ bufferSize: 1, refCount: true })
      )

    const childRouteFooterConfig$ = this.router.events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      startWith(null),
      map(() => this.currentChildRouteFooterConfig()),
      distinctUntilChanged(
        (previous, current) =>
          previous.showFooter === current.showFooter &&
          previous.showFooterInMobileApp === current.showFooterInMobileApp
      )
    )

    this.showFooter$ = combineLatest([
      this.configurationService.isMobileApp$,
      childRouteFooterConfig$
    ]).pipe(
      map(([isMobileApp, footerConfig]) => {
        return isMobileApp
          ? footerConfig.showFooterInMobileApp
          : footerConfig.showFooter
      }),
      distinctUntilChanged()
    )
  }

  private currentChildRouteFooterConfig(): AppShellFooterConfig {
    let route = this.activatedRoute
    let showFooter = route.snapshot.data.layout?.showFooter !== false
    let showFooterInMobileApp =
      route.snapshot.data.layout?.showFooterInMobileApp === true

    while (route.firstChild) {
      route = route.firstChild
      showFooter =
        showFooter && route.snapshot.data.layout?.showFooter !== false
      showFooterInMobileApp =
        showFooterInMobileApp ||
        route.snapshot.data.layout?.showFooterInMobileApp === true
    }

    return {
      showFooter,
      showFooterInMobileApp: showFooter && showFooterInMobileApp
    }
  }
}
